import { FC } from 'react';
import { TypesButton } from '../../../../../../constants/ButtonTypes';
import { SizesButton } from '../../../../../../constants/SizeButton';
import * as S from '../../styles';

interface Props {
  onCancel?: () => void;
  onSave?: () => void;
}

export const MainFormControls: FC<Props> = ({ onCancel, onSave }) => (
    <S.ButtonsWrapper>
        <S.ButtonsContainer>
            <S.StyledButton
                typeButton={TypesButton.SECONDARY}
                size={SizesButton.M}
                onClick={onCancel}
            >
                Отменить
            </S.StyledButton>
            <S.StyledButton
                typeButton={TypesButton.PRIMARY}
                size={SizesButton.M}
                onClick={onSave}
            >
                Сохранить изменения
            </S.StyledButton>
        </S.ButtonsContainer>
    </S.ButtonsWrapper>
);
